// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bKH7ba9Y3AErDXUt {
    color: var(--lok-color-text-disabled);
    font: var(--lok-typography-body-caption-default);
    text-align: center;
}

.P7CzHRcVQSU0bwc0 {
    font: var(--lok-typography-body-caption-default);
}

._v0a_n130Hwg14xi {
    position: relative;
}

/* Shrinks the full EvaluationMetricsTable down into a small preview for the upsell. */
.O6SqyC8QsQbArOMR {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 250px;
    height: 165px;

    td {
        font-size: 10px !important;
        padding: 7px 6px 7px 5px;
    }

    th {
        font-size: 10px !important;
        padding: 7px 40px;
        background-color: var(--lok-color-background-surface-default);
    }

    svg {
        width: 7px;
    }
}

.EtXhvbcxEM8B6PPE {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    position: absolute;
    top: -20px;
    left: -35px;
}

.V9_NgJ5XA4oe4Ufk {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--lok-spacing-1);

    background-color: var(--lok-color-background-input-default);
    border: 1px solid var(--lok-color-border-default);
    border-radius: var(--lok-radius-button-default);
    padding: var(--lok-spacing-2) var(--lok-spacing-3);
    width: 95px;

    box-shadow: 0px 10px 20px 2px #26262605,
            0px 8px 16px 0px #2626260A,
            0px 4px 6px 0px #2626260A,
            0px 0px 2px 0px #2626261A;

    img {
        width: 50%;
    }
}

.JdJQ2hzRvxYI0wRh {
    position: absolute;
    width: 650px;
    right: -425px;
    border-radius: var(--lok-radius-l);
    box-shadow: 0px 10px 20px 2px #26262605,
                0px 8px 16px 0px #2626260A,
                0px 4px 6px 0px #2626260A,
                0px 0px 2px 0px #2626261A;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/LandingPageBanner/components/EvalsBanner.module.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,gDAAgD;IAChD,kBAAkB;AACtB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;AACtB;;AAEA,sFAAsF;AACtF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;;IAEb;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,6DAA6D;IACjE;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;;IAErB,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;;IAEzB,2DAA2D;IAC3D,iDAAiD;IACjD,+CAA+C;IAC/C,kDAAkD;IAClD,WAAW;;IAEX;;;qCAGiC;;IAEjC;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC;;;yCAGqC;AACzC","sourcesContent":[".subText {\n    color: var(--lok-color-text-disabled);\n    font: var(--lok-typography-body-caption-default);\n    text-align: center;\n}\n\n.bodyText {\n    font: var(--lok-typography-body-caption-default);\n}\n\n.ctaContainer {\n    position: relative;\n}\n\n/* Shrinks the full EvaluationMetricsTable down into a small preview for the upsell. */\n.tableContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    width: 250px;\n    height: 165px;\n\n    td {\n        font-size: 10px !important;\n        padding: 7px 6px 7px 5px;\n    }\n\n    th {\n        font-size: 10px !important;\n        padding: 7px 40px;\n        background-color: var(--lok-color-background-surface-default);\n    }\n\n    svg {\n        width: 7px;\n    }\n}\n\n.fakeButtonContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n\n    position: absolute;\n    top: -20px;\n    left: -35px;\n}\n\n.fakeButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--lok-spacing-1);\n\n    background-color: var(--lok-color-background-input-default);\n    border: 1px solid var(--lok-color-border-default);\n    border-radius: var(--lok-radius-button-default);\n    padding: var(--lok-spacing-2) var(--lok-spacing-3);\n    width: 95px;\n\n    box-shadow: 0px 10px 20px 2px #26262605,\n            0px 8px 16px 0px #2626260A,\n            0px 4px 6px 0px #2626260A,\n            0px 0px 2px 0px #2626261A;\n\n    img {\n        width: 50%;\n    }\n}\n\n.tableInner {\n    position: absolute;\n    width: 650px;\n    right: -425px;\n    border-radius: var(--lok-radius-l);\n    box-shadow: 0px 10px 20px 2px #26262605,\n                0px 8px 16px 0px #2626260A,\n                0px 4px 6px 0px #2626260A,\n                0px 0px 2px 0px #2626261A;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subText": `bKH7ba9Y3AErDXUt`,
	"bodyText": `P7CzHRcVQSU0bwc0`,
	"ctaContainer": `_v0a_n130Hwg14xi`,
	"tableContainer": `O6SqyC8QsQbArOMR`,
	"fakeButtonContainer": `EtXhvbcxEM8B6PPE`,
	"fakeButton": `V9_NgJ5XA4oe4Ufk`,
	"tableInner": `JdJQ2hzRvxYI0wRh`
};
export default ___CSS_LOADER_EXPORT___;
